import {combineReducers} from "redux";
import hospitalTypeSettingViewModel from "./hospitalTypeSettingViewModel";
import districtSettingViewModel from "./districtSettingViewModel";
import medicalGroupSettingViewModel from "./medicalGroupSettingViewModel";
import hospitalSettingViewModel from "./hospitalSettingViewModel";

const rootViewModel = combineReducers({
    hospitalTypeSettingViewModel,
    districtSettingViewModel,
    medicalGroupSettingViewModel,
    hospitalSettingViewModel,
});

export default rootViewModel;
